import axios from 'axios';
import { detectBrand } from './brandDetection';

let lastIdentifyKey = "";

export function identifyKlaviyo(email, phoneNumber, ip, externalId, profile = {}) {
  if (!email) return;
  const brand = detectBrand();
  const payload = {
    email,
    phone_number: phoneNumber || undefined,
    ip_address: ip || undefined,
    external_id: externalId || undefined,
    first_name: profile.firstName || undefined,
    last_name: profile.lastName || undefined,
    brand_id: brand.id,
  };
  const identifyKey = JSON.stringify(payload);
  if (identifyKey === lastIdentifyKey) return;

  axios.post('/api/public/events/identify', payload)
    .then(() => {
      lastIdentifyKey = identifyKey;
    })
    .catch(() => {});
}

export function trackKlaviyo(eventName, properties = {}) {
  const brand = detectBrand();
  axios.post('/api/public/events/track-for-profile', {
    event_name: eventName,
    email: properties.email,
    properties,
    brand_id: brand.id,
  }).catch(() => {});
}

export function subscribeKlaviyo(email, pageUrl, phoneNumber, profile = {}) {
  if (!email) return;
  const brand = detectBrand();
  axios.post('/api/public/events/subscribe', {
    email,
    page_url: pageUrl || window.location.href,
    phone_number: phoneNumber || undefined,
    first_name: profile.firstName || undefined,
    last_name: profile.lastName || undefined,
    brand_id: brand.id,
  }).catch(() => {});
}
